import { render, staticRenderFns } from "./record.vue?vue&type=template&id=49cedaba&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=49cedaba&prod&lang=scss&scoped=true"
import style1 from "./record.vue?vue&type=style&index=1&id=49cedaba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cedaba",
  null
  
)

export default component.exports